import React from "react";
import { useGetShippedByUserQuery } from "../../services/rtkApi/contributeApi";

// Public "Shipped Ideas" credit for a member — their pitched ideas that became real
// features. Renders nothing until they have at least one, so it only ever appears as
// earned credit. Used on the profile page (and reusable on any public profile).
export default function ShippedIdeasPanel({ username }: { username: string }) {
  const { data } = useGetShippedByUserQuery(username, { skip: !username });
  const shipped = data?.shipped || [];
  if (!username || shipped.length === 0) return null;

  return (
    <div className="w-full max-w-[800px] mt-3">
      <h1 className="text-2xl text-[#222] mb-2 ml-[30px]">Ideas You've Shipped ✨</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {shipped.map((s) => (
          <div key={s.id} className="border-brutal border-ink rounded-sm bg-paper shadow-brutal-sm p-3">
            <div className="font-bold text-sm break-words">{s.title}</div>
            {s.pitch && <div className="text-xs text-ink/70 mt-1 whitespace-pre-wrap break-words">{s.pitch}</div>}
            {s.featureUrl && (
              <a href={s.featureUrl} target="_blank" rel="noopener noreferrer" className="text-xs underline text-sky-700 break-all">
                {s.featureTitle || "see the feature"}
              </a>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
